import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DashService } from '@modules/dash-board/dash.service';
import { ApiService } from '@services/api/api.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { SharedDataService } from '@services/shared-data.service';
import { MessageService } from '@services/util/message.service';
import { PrimeIcons } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-library-menu',
  templateUrl: './library-menu.component.html',
  styleUrls: ['./library-menu.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(90deg)' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
    ]),
  ],
})
export class LibraryMenuComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('fileUpload') fileUpload: ElementRef;

  @Input() isContractLibrary = false;
  @Input() propertyId = '';
  @Input() hidePropertyLibrary = false;
  @Input() librarydata: [] = [];
  @Input() fileUploadInputId = 'fileUpload';
  // Image Send to property Listing
  @Output() displayImageEmitter = new EventEmitter<String>();

  private resizeSubscription: Subscription;
  contextmenuVisible = false;
  contextmenuX = 0;
  contextmenuY = 0;
  screenWidth: any;
  mobToggle: any = false;
  slideMenuViewportHeight: number = 200;
  selectedMenuItemName: String = '';
  hideNewBtn = false;
  expanded = {};
  lowResolutionImage: String = '';
  highResolutionImage: String = '';

  // Default Variables
  library_type = 'private';

  public allItems: any = [];
  public items: any = [];
  public newMenuLinks = [];

  // Modal
  subjectEventSubscription: Subscription;
  subscriptionOffice: Subscription;
  private messageSubscription: Subscription;

  // Auth
  public authUserID = null;

  // Sidebar
  selectedSidebarLink: any;

  // Folder
  fileUploadingLoader: boolean = false;

  //Office
  officeId: String = '';
  officeName: String = '';

  constructor(
    private _sharedDataService: SharedDataService,
    private Api: ApiService,
    private Auth: AuthService,
    private localStorageService: LocalStorageService,
    public message: MessageService,
    private dash: DashService,
    private router: Router
  ) {
    this.authUserID = Crypto.decrypt(this.localStorageService.GetItem('uid'));
    // Menu
    // Add New Folder File

    // if(true){
    //   this.newMenuLinks = [
    //     { label: 'File Upload (Public)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('public') },
    //     { label: 'File Upload (Private)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('private') },
    //     { label: 'Create Workspace', icon: PrimeIcons.INBOX, command: () => this.triggerWorkspaceCreation() },
    //   ];
    // } else {
    //   this.newMenuLinks = [
    //     { label: 'Folder', icon: 'pi pi-folder', command: () => this.showAddFolderModal() },
    //     { label: 'File Upload (Public)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('public') },
    //     { label: 'File Upload (Private)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('private') },
    //     { label: 'Create Workspace', icon: PrimeIcons.INBOX, command: () => this.triggerWorkspaceCreation() },
    //   ];
    // }

    this.newMenuLinks = [
      { label: 'Folder', icon: 'pi pi-folder', command: () => this.showAddFolderModal() },
      { label: 'File Upload (Public)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('public') },
      { label: 'File Upload (Private)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('private') },
      { label: 'Create Workspace', icon: PrimeIcons.INBOX, command: () => this.triggerWorkspaceCreation() },
    ];

    this.messageSubscription = message.getMessage().subscribe({
      next: f => {
        if (f.isHideFolder) {
          this.newMenuLinks = [
            { label: 'File Upload (Public)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('public') },
            { label: 'File Upload (Private)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('private') },
          ];
        } else if (f.isShowFolder) {
          this.newMenuLinks = [{ label: 'Folder', icon: 'pi pi-folder', command: () => this.showAddFolderModal() }];
        } else {
          this.newMenuLinks = [
            { label: 'Folder', icon: 'pi pi-folder', command: () => this.showAddFolderModal() },
            { label: 'File Upload (Public)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('public') },
            { label: 'File Upload (Private)', icon: 'pi pi-cloud-upload', command: () => this.triggerFileUpload('private') },
          ];
        }
      },
    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // Check if 'libraryData' has changed and has a new value
    if (changes?.['librarydata']?.currentValue) {
      // Recursively select folders and update items list
      this.allItems = this.items = await this.selectFolder_recursive(this.propertyId, changes?.['librarydata']?.currentValue, true);
      // Reset high and low-resolution images
      this.highResolutionImage = this.lowResolutionImage = '';
      // Fetch high and low-resolution folder paths
      await this.GetHighLowResolutionFolderPath(this.allItems);
      // Emit the image path, prioritizing low resolution, then high resolution, otherwise an empty string
      this.displayImageEmitter.emit(
        this.lowResolutionImage != '' ? this.lowResolutionImage : this.highResolutionImage != '' ? this.highResolutionImage : ''
      );
    }
  }

  ngOnInit(): void {
    // Retrieve office ID from local storage
    this.officeId = Crypto.decrypt(this.localStorageService.GetItem('officeid'));

    // Subscribe to library data handler observable
    this.subjectEventSubscription = this._sharedDataService?.libraryGetDataHandlerObservable.subscribe({
      next: response => {
        // Trigger function handler only if propertyId is empty
        if (this.propertyId == '') {
          this.triggerFuncHandler(response);
        }
      },
    });

    // Unsubscribe from subject event subscription
    this.subjectEventSubscription?.unsubscribe();

    // Subscribe to office ID changes
    this.subscriptionOffice = this.Auth.getOfficeId().subscribe({
      next: response => {
        this.officeId = response;
        // Fetch sidebar items if propertyId is empty
        if (this.propertyId == '') {
          this.getSidebarItems();
        }
      },
    });

    // Fetch sidebar items if propertyId is empty; otherwise, remove the last menu link
    if (this.propertyId == '') {
      this.getSidebarItems();
    } else {
      this.newMenuLinks.pop();
    }

    // Subscribe to screen size changes to toggle mobile view
    this.resizeSubscription = this.dash.screenSize$.subscribe({
      next: size => {
        this.screenWidth = size.width;
        this.mobToggle = this.screenWidth < 567;
      },
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from subject event subscription to prevent memory leaks
    this.subjectEventSubscription?.unsubscribe();

    // Unsubscribe from office ID changes
    this.subscriptionOffice?.unsubscribe();
    this.messageSubscription?.unsubscribe();

    // Unsubscribe from screen resize subscription if it exists
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  // Fetches sidebar items for the user's library
  getSidebarItems() {
    // Retrieve office ID from local storage
    this.officeId = Crypto.decrypt(this.localStorageService.GetItem('officeid'));

    // Check if the user is authenticated
    if (this.authUserID) {
      var param = [
        {
          user_id: this.authUserID,
          library_type: this.library_type,
          office_id: this.officeId,
        },
      ];

      // Fetch user's folders from API
      this.Api.get('/library/my-folders', param[0]).subscribe({
        next: response => {
          // Fetch user's favorite folders/files
          this.Api.get('/library/get-fav-folder-file', { userId: this.authUserID, library_type: this.library_type }).subscribe({
            next: resFav => {
              // Check if 'Favorites' label exists in the response data
              if (response?.data?.filter(x => x.label === 'Favourites')?.length > 0) {
                response.data.filter(x => x.label === 'Favourites')[0].items = this.extractedFavoriteFolder(resFav?.data);
                this.allItems = this.items = response?.data?.map(folder => ({ ...folder, type: 'folder' }));
              }
            },
          });

          // Retrieve office name from local storage
          let office_name = Crypto.decrypt(this.localStorageService.GetItem('office_name'));

          // Map folder data to include type property
          this.allItems = this.items = response?.data?.map(folder => ({ ...folder, type: 'folder' }));

          // Determine the active sidebar menu link based on the current route
          this.getActivatedSideMenuLink(this.router.url.toLowerCase()?.split('?id='), office_name);
        },
      });
    }
  }

  // Determines and sets the activated sidebar menu link based on the URL
  getActivatedSideMenuLink(splittedurl: any[], officeName = '') {
    if (splittedurl?.length == 2) {
      this.selectedSidebarLink = splittedurl?.[1];
    } else {
      let selectedUrl = splittedurl?.[0]?.split('/')?.[splittedurl?.[0]?.split('/')?.length - 1];
      switch (selectedUrl) {
        case 'private':
          this.selectedSidebarLink = 'My Files';
          break;
        case 'office':
          this.selectedSidebarLink = officeName;
          break;
        case 'workspace':
          this.selectedSidebarLink = 'My Workspace';
          break;
        case 'shared':
          this.selectedSidebarLink = 'Shared with me';
          this.hideNewBtn = true;
          break;
        case 'recent':
          this.selectedSidebarLink = 'Recent';
          this.hideNewBtn = true;
          break;
        case 'favourite':
          this.selectedSidebarLink = 'Favourites';
          this.hideNewBtn = true;
          break;
        case 'trash':
          this.selectedSidebarLink = 'Trash';
          this.hideNewBtn = true;
          break;
        default:
          break;
      }
    }
  }

  // Handles first-level sidebar navigation clicks
  sidebarLev1(event, item, itemId) {
    event?.preventDefault();
    event?.stopPropagation();

    this.hideNewBtn = false;

    // If item ID is undefined or null, navigate based on label
    if (item._id === undefined || item._id == null) {
      if (item?.label == 'My Files') {
        this.router.navigateByUrl('/library/private');
      }
      if (item?.label == 'My Workspace') {
        this.router.navigateByUrl('/library/private/workspace');
      }
      if (item?.label == 'Shared with me') {
        this.router.navigateByUrl('/library/private/shared');
        this.hideNewBtn = true;
      }
      if (item?.label == 'Recent') {
        this.router.navigateByUrl('/library/private/recent');
        this.hideNewBtn = true;
      }
      if (item?.label == 'Favourites') {
        this.router.navigateByUrl('/library/private/favourite');
        this.hideNewBtn = true;
      }
      if (item?.label == 'Trash') {
        this.router.navigateByUrl('/library/private/trash');
        this.hideNewBtn = true;
      }
      if (item?.icon == 'pi pi-briefcase') {
        this.router.navigateByUrl('/library/private/office');
      }
    }
    // If item has an ID and no property ID, navigate accordingly
    else if (item?._id && this.propertyId == '') {
      this.router.navigateByUrl(`/library/private?Id=${item?._id}`);
    }
    // If item has an ID and a property ID, trigger an event
    else if (item?._id && this.propertyId != '') {
      this._sharedDataService.triggerFuncEventHandler({ dataset: item?._id, method: 'propertyfolders' });
    }

    // Set selected sidebar link and menu item name
    this.selectedSidebarLink = itemId;
    this.selectedMenuItemName = item?.label;
  }

  // Handles triggered function events
  triggerFuncHandler(response) {
    switch (response?.method) {
      case 'refresh':
        this.getSidebarItems(); // Refresh sidebar items
        break;
      default:
        break;
    }
  }
  // Duplicate
  makeAcopyFolderFile(data: any) {
    this._sharedDataService.triggerFuncEventHandler({ dataset: data, method: 'makecopy' });
  }
  // #Move
  showMoveFolderModal(data) {
    this._sharedDataService.triggerFuncEventHandler({ dataset: data, method: 'movefilefolder' });
  }
  // #Rename
  showRenameModal(data) {
    this._sharedDataService.triggerFuncEventHandler({ dataset: data, method: 'renamefilefolder' });
  }
  // #Delete
  removeFolderFile(data) {
    this._sharedDataService.triggerFuncEventHandler({ dataset: data, method: 'remove' });
  }
  // #Models
  showAddFolderModal() {
    this._sharedDataService.triggerFuncEventHandler({ dataset: null, method: 'newfilefolder' });
  }
  // #Files
  triggerFileUpload(type) {
    this._sharedDataService.triggerFuncEventHandler({
      dataset: null,
      method: 'fileupload',
      file_uploader_id: this.fileUploadInputId,
      file_type: type,
    });
  }
  // Workspace
  triggerWorkspaceCreation() {
    this._sharedDataService.triggerFuncEventHandler({ dataset: null, method: 'workspacecreation' });
  }

  // Always returns true, likely used for controlling UI visibility.
  get show(): boolean {
    return true;
  }

  // Handles item selection in the menu, toggling expansion for items with children.
  onItemSelected(event, menu: any) {
    event?.preventDefault();
    event?.stopPropagation();

    // Check if the menu has sub-items or children
    if ((menu?.items && menu?.items?.length) || (menu?.childrens && menu?.childrens?.length)) {
      // Toggle expansion state based on label or name
      if (menu?.label) {
        this.expanded[menu?.label] = !this.expanded[menu?.label];
      } else if (menu?.name) {
        this.expanded[menu?.name] = !this.expanded[menu?.name];
      }
    }
  }

  // Handles right-click events on menu items to show or hide the context menu.
  rightClickHandler(event, menu) {
    event?.preventDefault();
    event?.stopPropagation();

    // Show context menu only if the item has an ID
    if (menu?._id) {
      this.contextmenuVisible = true;
    } else {
      this.contextmenuVisible = false;
    }

    // Set context menu position based on cursor location
    this.contextmenuX = event?.pageX;
    this.contextmenuY = event?.clientY - 190; // Adjust for UI positioning
  }

  // Filters out deleted or non-folder items from the favorite folders list recursively.
  extractedFavoriteFolder(data: any) {
    if (data !== undefined && data != null) {
      for (let index = 0; index < data?.length; index++) {
        // Remove files from the list
        if (data[index]?.type === 'file') {
          data?.splice(index, 1);
        }
        // Remove deleted items
        if (data[index]?.is_deleted) {
          data?.splice(index, 1);
        }
        // Recursively check for children folders and clean them
        if (data[index]?.childrens !== undefined && data[index]?.childrens != null && data[index]?.childrens?.length > 0) {
          this.extractedFavoriteFolder(data[index]?.childrens);
        }
      }
      return data;
    }
  }

  // Recursively searches for a folder by ID and returns its children if found.
  selectFolder_recursive = async (fileOrFolderId, array, setFolderName) => {
    return new Promise(async resolve => {
      if (fileOrFolderId) {
        for (const node of array) {
          // Check if the node is a folder
          if (node?.type === 'folder') {
            // If the folder matches the searched ID, process its children
            if (node?._id == fileOrFolderId || node?.ref_id === fileOrFolderId) {
              if (node?.childrens?.filter(r => r.type == 'folder')?.length > 0) {
                resolve(
                  node?.childrens
                    ?.filter(r => r.type == 'folder')
                    ?.map(r =>
                      r?.childrens?.filter(r => r.type == 'folder')?.length > 0
                        ? {
                            ...r,
                            label: r?.name,
                            command: event => {
                              this.loadMenuItemAction(event);
                            },
                            items: r?.childrens
                              ?.filter(r => r.type == 'folder')
                              ?.map(sr => ({
                                ...sr,
                                label: sr?.name,
                                command: event => {
                                  this.loadMenuItemAction(event);
                                },
                              })),
                          }
                        : {
                            ...r,
                            label: r?.name,
                            command: event => {
                              this.loadMenuItemAction(event);
                            },
                          }
                    )
                );
              } else {
                delete node?.items;
              }
            }
            // If the current folder has more sub-folders, continue the recursion
            if (node?.childrens && node?.childrens?.filter(r => r.type == 'folder')?.length > 0) {
              resolve(
                this.selectFolder_recursive(
                  fileOrFolderId,
                  node.childrens
                    ?.filter(r => r.type == 'folder')
                    ?.map(r => ({
                      ...r,
                      label: r?.name,
                      items: r?.childrens
                        ?.filter(r => r.type == 'folder')
                        ?.map(sr => ({
                          ...sr,
                          label: sr?.name,
                          command: event => {
                            this.loadMenuItemAction(event);
                          },
                        })),
                    })),
                  setFolderName
                )
              );
            } else {
              delete node?.items;
            }
          }
        }
      }
    });
  };

  // Calls sidebarLev1 function with event data to trigger a menu action.
  loadMenuItemAction(event) {
    this.sidebarLev1(null, event?.item, event?.item?._id);
  }

  // Recursively searches for a folder named "Property Images" and extracts the first low-resolution image path.
  GetHighLowResolutionFolderPath(data) {
    if (!data) {
      return;
    } else {
      for (const item of data) {
        // Check if the folder name contains "property images" (case-insensitive)
        if (item?.name !== undefined && item?.name != null && item?.name?.toLowerCase()?.indexOf(`property images`) != -1) {
          // Find the first image file (JPEG or PNG) in the folder
          let picture = item?.childrens?.filter(
            file => file?.type === 'file' && (file?.file_type === 'image/jpeg' || file.file_type === 'image/png' || file.file_type === 'image/jpeg')
          )?.[0]?.path;

          // Store the found image path
          if (picture) {
            this.lowResolutionImage = picture;
          }
        }

        // Recursively check in child folders
        if (item?.childrens?.length > 0) {
          this.GetHighLowResolutionFolderPath(item?.childrens);
        }
      }
      return data;
    }
  }

  // Determines if a chevron right icon should be displayed based on item contents.
  isChevronRightIconDisplayed(item) {
    if (!item) {
      return false;
    }

    // If the item has sub-items or child folders, show the chevron icon
    if (item?.items?.length > 0 || item?.childrens?.filter(res => res.type === 'folder')?.length > 0) {
      return true;
    }
    return false;
  }
}
